import { walkWidgetPropsTree } from '@juvare/widget-ui/Widget';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setModalChildSkipValidate(childProps) {
    for (const props of childProps) {
        walkWidgetPropsTree(props, (p) => {
            p.internalData.modalChildSkipValidate = true;
        });
    }
}
